import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Milou from "./views/Milou.vue";
import Signature from "./views/Signature.vue";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/milou",
            name: "milou",
            component: Milou
        },
        {
            path: "/signature",
            name: "signature",
            component: Signature
        }
    ]
});
